import { render, staticRenderFns } from "./QuizForm.vue?vue&type=template&id=77a9c456&scoped=true&"
import script from "./QuizForm.vue?vue&type=script&lang=js&"
export * from "./QuizForm.vue?vue&type=script&lang=js&"
import style0 from "./QuizForm.vue?vue&type=style&index=0&id=77a9c456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a9c456",
  null
  
)

export default component.exports